module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, _vm._l((_vm.reposCat), function(cat, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "py-2 title grey lighten-4"
    }, [_vm._v("\n              " + _vm._s(cat.repos_cat) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0",
      style: (_vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }).length > 5 ? 'overflow-y: scroll; height: 300px; padding: 1rem 1rem 1rem 0px;' : '')
    }, [_c('v-data-table', {
      attrs: {
        "headers": cat.repos_cat_id === 1 ? _vm.reposHeaderAgreement : _vm.reposHeader,
        "items": _vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }),
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [(cat.repos_cat_id === 1) ? _c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateReposit(props.item)
              }
            }
          }, [_c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(" " + _vm._s(props.item.doc_name ? props.item.doc_name : '-') + " ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": props.item.doc_url,
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
            attrs: {
              "small": "",
              "icon": "",
              "onclick": "event.stopPropagation()"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.upload_dt ? _vm.handy.formatDate(props.item.upload_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.vendor_name ? props.item.vendor_name : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.scope_of_work ? props.item.scope_of_work : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_start_dt ? _vm.handy.formatDate(props.item.contract_start_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_end_dt ? _vm.handy.formatDate(props.item.contract_end_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_value ? _vm.handy.formatCur(props.item.contract_value) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.payment_frequency ? props.item.payment_frequency : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contact_phone ? props.item.contact_phone : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contact_email ? props.item.contact_email : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.remarks ? props.item.remarks : '-'))])]) : _vm._e(), _vm._v(" "), (cat.repos_cat_id != 1) ? _c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateReposit(props.item)
              }
            }
          }, [_c('td', [_vm._v(" " + _vm._s(props.item.doc_name ? props.item.doc_name : '-') + " ")]), _vm._v(" "), _c('td', [_c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": props.item.doc_url,
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
            attrs: {
              "small": "",
              "icon": "",
              "onclick": "event.stopPropagation()"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.upload_dt ? _vm.handy.formatDBDateTime(props.item.upload_dt) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remarks ? props.item.remarks : '-'))])]) : _vm._e()]
        }
      }], null, true)
    })], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareRepository()
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Add Repository")])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showRepositEdit),
      callback: function($$v) {
        _vm.showRepositEdit = $$v
      },
      expression: "showRepositEdit"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-2 py-2",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Repository\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRepositEdit = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.reposCat,
      "label": "Repository Category",
      "item-text": "repos_cat",
      "item-value": "repos_cat_id",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lReposit.repos_cat_id),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "repos_cat_id", $$v)
      },
      expression: "lReposit.repos_cat_id"
    }
  })], 1), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.vendorList,
      "label": "Vendor Name",
      "item-text": "vendor_name",
      "item-value": "vendor_id",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSelectedVendorDetails()
      }
    },
    model: {
      value: (_vm.lReposit.rep_vendor_id),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "rep_vendor_id", $$v)
      },
      expression: "lReposit.rep_vendor_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact Name",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_name),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_name", $$v)
      },
      expression: "lReposit.contact_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact Number",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_phone", $$v)
      },
      expression: "lReposit.contact_phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact email",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_email", $$v)
      },
      expression: "lReposit.contact_email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Contract Value",
      "hide-details": "",
      "type": "Number",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lReposit.contract_value),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_value", $$v)
      },
      expression: "lReposit.contract_value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "contractStartDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lReposit.contract_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReposit, "contract_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReposit, "contract_start_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "slot": "activator",
            "label": "Contract Start Date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "required": ""
          },
          slot: "activator",
          model: {
            value: (_vm.lReposit.contract_start_dt),
            callback: function($$v) {
              _vm.$set(_vm.lReposit, "contract_start_dt", $$v)
            },
            expression: "lReposit.contract_start_dt"
          }
        }, on))]
      }
    }], null, false, 1021666470),
    model: {
      value: (_vm.contractStartDt),
      callback: function($$v) {
        _vm.contractStartDt = $$v
      },
      expression: "contractStartDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReposit.contract_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_start_dt", $$v)
      },
      expression: "lReposit.contract_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.contractStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.contractStartDt.save(_vm.lReposit.contract_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "contractEndDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lReposit.contract_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReposit, "contract_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReposit, "contract_end_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "slot": "activator",
            "label": "Contract End Date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "required": ""
          },
          slot: "activator",
          model: {
            value: (_vm.lReposit.contract_end_dt),
            callback: function($$v) {
              _vm.$set(_vm.lReposit, "contract_end_dt", $$v)
            },
            expression: "lReposit.contract_end_dt"
          }
        }, on))]
      }
    }], null, false, 1769829830),
    model: {
      value: (_vm.contractEndDt),
      callback: function($$v) {
        _vm.contractEndDt = $$v
      },
      expression: "contractEndDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReposit.contract_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_end_dt", $$v)
      },
      expression: "lReposit.contract_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.contractEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.contractEndDt.save(_vm.lReposit.contract_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.frequency_list,
      "label": "Payment Frequency",
      "hide-details": ""
    },
    model: {
      value: (_vm.lReposit.payment_frequency),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "payment_frequency", $$v)
      },
      expression: "lReposit.payment_frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Scope of Work",
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lReposit.scope_of_work),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "scope_of_work", $$v)
      },
      expression: "lReposit.scope_of_work"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Remarks (if any)",
      "rows": "2",
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lReposit.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "remarks", $$v)
      },
      expression: "lReposit.remarks"
    }
  })], 1), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .eml, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .eml, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length === 0) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteReposit(_vm.lReposit)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent black--text",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-49ecdcf5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Repository.vue
// module id = 852
// module chunks = 22